import { render, staticRenderFns } from "./searchItem.vue?vue&type=template&id=0fdba206&scoped=true&"
import script from "./searchItem.vue?vue&type=script&lang=js&"
export * from "./searchItem.vue?vue&type=script&lang=js&"
import style0 from "./searchItem.vue?vue&type=style&index=0&id=0fdba206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdba206",
  null
  
)

export default component.exports